"use strict";

import 'slick-carousel';
import {loadImg} from "@elements/lazy-img";
import {onEnterViewPort} from "@elements/viewport-utils";

export function initInScope($scope) {
    let $slider = $scope.find('.js-media-gallery-slider');

    $slider.each(function () {

        let $sliderMain = $(this).find('.js-media-gallery-slider__main');
        let $sliderNav = $(this).find('.js-media-gallery-slider__nav');
        let $pagingContainer = $(this).find('.js-media-gallery-slider__paging');


        let arrowPrevMarkup = '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-left"></span></button>',
            arrowNextMarkup = '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-right"></span></button>';


        let sliderOptionsMain = {
            nextArrow: arrowNextMarkup,
            prevArrow: arrowPrevMarkup,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $sliderNav,
            appendArrows : $(this).find('.js-media-gallery-slider__arrows')
        };


        let sliderOptionsNav = {
            arrows:false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: $sliderMain,
            focusOnSelect: true,
        };

        customPaging($sliderMain,$pagingContainer);

        initSlider($sliderMain, sliderOptionsMain);
        initSlider($sliderNav, sliderOptionsNav);

    });

}

function initSlider($slider, sliderOptions,) {
    $slider.slick(sliderOptions).on('afterChange', function (event, slick, currentSlide) {
        preloadNSlide(slick, currentSlide + 1, sliderOptions.slidesToShow);
    });

    onEnterViewPort($slider, function ($slider) {
        preloadNSlide($slider.slick('getSlick'), 1, sliderOptions.slidesToShow);
    });
}

function customPaging($slider, $pagingContainer) {
    $slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){

        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        let i = (currentSlide ? currentSlide : 0) + 1;
        $pagingContainer.html('<strong>' + i + '</strong>' + '/' + slick.slideCount);
    });
}

export function preloadSlide(slick, slideIndex) {
    let slideToPreload = slick.$slides[slideIndex];

    if (slideToPreload) {
        let $imgToPreload = $(slideToPreload).find('.js-lazy-img');
        if ($imgToPreload && $imgToPreload.length) {
            loadImg($imgToPreload);
        }
    }
}

export function preloadNSlide(slick, start, n) {
    for (let i = 0; i < n; i++) {
        preloadSlide(slick, start + n);
    }
}
